import axiosInstance from '../config/axios.js';

const API_BASE = '/users';

const userService = {
  // Get all users with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get user by ID
  getById: async (userId) => {
    const response = await axiosInstance.get(`${API_BASE}/${userId}`);
    return response.data;
  },

  // Create new user
  create: async (userData, profilePhoto = null, documentAttachment = null) => {
    const formData = new FormData();
    
    // Append all user data
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined) {
        if (key === 'cc_email' || key === 'bcc_email') {
          formData.append(key, JSON.stringify(userData[key]));
        } else {
          formData.append(key, userData[key]);
        }
      }
    });

    // Append files if provided
    if (profilePhoto) {
      formData.append('profile_photo', profilePhoto);
    }
    if (documentAttachment) {
      formData.append('document_attachment', documentAttachment);
    }

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update user
  update: async (userId, userData, profilePhoto = null, documentAttachment = null) => {
    const formData = new FormData();
    
    // Append all user data
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined) {
        if (key === 'cc_email' || key === 'bcc_email') {
          formData.append(key, JSON.stringify(userData[key]));
        } else {
          formData.append(key, userData[key]);
        }
      }
    });

    // Append files if provided
    if (profilePhoto) {
      formData.append('profile_photo', profilePhoto);
    }
    if (documentAttachment) {
      formData.append('document_attachment', documentAttachment);
    }

    const response = await axiosInstance.put(`${API_BASE}/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete user (soft delete)
  delete: async (userId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${userId}`);
    return response.data;
  },

  // Activate user
  activate: async (userId) => {
    const response = await axiosInstance.post(`${API_BASE}/${userId}/activate`);
    return response.data;
  },

  // Get user profile photo
  getProfilePhoto: (userId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${userId}/profile-photo`;
  },

  // Get user document attachment
  getDocumentAttachment: (userId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${userId}/document-attachment`;
  },

  // Get users by role
  getByRole: async (roleId) => {
    const response = await axiosInstance.get(`${API_BASE}/role/${roleId}`);
    return response.data;
  },

  // Get users by city
  getByCity: async (city) => {
    const response = await axiosInstance.get(`${API_BASE}/city/${city}`);
    return response.data;
  },

  // Send credentials email
  sendCredentials: async (userId) => {
    const response = await axiosInstance.post(`${API_BASE}/${userId}/send-credentials`);
    return response.data;
  },

  // Get all clients (users with Client role)
  getClients: async (page = null, perPage = null, params = {}) => {
    const queryParams = { ...params };
    
    // Only add pagination if page and perPage are provided.
    // Otherwise request all clients so dropdowns are not capped at the API default (10).
    if (page !== null && perPage !== null) {
      queryParams.page = page;
      queryParams.per_page = perPage;
    } else {
      queryParams.all = 'true';
    }
    
    const response = await axiosInstance.get(`${API_BASE}/clients`, { params: queryParams });
    return response.data;
  },

  // Get client by ID
  getClientById: async (userId) => {
    const response = await axiosInstance.get(`${API_BASE}/clients/${userId}`);
    return response.data;
  },

  // Get clients by city
  getClientsByCity: async (city) => {
    const response = await axiosInstance.get(`${API_BASE}/clients/city/${city}`);
    return response.data;
  }
};

export default userService;